"use client";

import Phone from "@homeinstead/icons/Phone";
import Image from "next/image";
import { cn } from "../../../utils/classnames";
import PhoneLink from "../../PhoneLink";

type CoBrandedPartnerColumnProps = {
  partnerLogo: {
    alt: string;
    height: number;
    src: string;
    width: number;
  };
  phoneNumber: string;
  scrolledDown: boolean;
};

function CoBrandedPartnerColumn({
  partnerLogo,
  phoneNumber,
  scrolledDown,
}: CoBrandedPartnerColumnProps) {
  return (
    <div className="flex shrink-0 items-center justify-end gap-2 sm:gap-3">
      <Image
        alt={partnerLogo.alt}
        className="hidden h-10 w-auto max-w-[120px] object-contain object-right sm:block sm:h-12 sm:max-w-[147px]"
        height={partnerLogo.height}
        priority
        src={partnerLogo.src}
        width={partnerLogo.width}
      />
      <div className="relative h-10 w-[120px] shrink-0 sm:hidden">
        <div
          aria-hidden={scrolledDown}
          className={cn(
            "absolute inset-0 flex items-center justify-end transition-opacity duration-300 ease-in-out",
            scrolledDown ? "pointer-events-none opacity-0" : "opacity-100",
          )}
        >
          <Image
            alt={partnerLogo.alt}
            className="h-10 w-auto max-w-[120px] object-contain object-right"
            height={partnerLogo.height}
            src={partnerLogo.src}
            width={partnerLogo.width}
          />
        </div>
        <div
          className={cn(
            "absolute inset-0 flex items-center justify-end transition-all duration-300 ease-in-out",
            scrolledDown ? "opacity-100" : "opacity-0",
          )}
          inert={!scrolledDown ? true : undefined}
        >
          <PhoneLink phoneNumber={phoneNumber} variant="friendly">
            <div className="flex flex-row items-center gap-2">
              <Phone className="fill-new-beginnings-base" /> Call us
            </div>
          </PhoneLink>
        </div>
      </div>
    </div>
  );
}

export { CoBrandedPartnerColumn };
